<template>
  <layout-block
    width="auto"
    :style="`font-family: monospace; font-size: 13.2px; background-color: ${color};`"
    padding="10px 10px"
    :margin="margin"
  >
    <div v-html="content"></div>
  </layout-block>
</template>

<script>
import LayoutBlock from '@/components/Layout/Block.vue'

export default {
  name: 'LpeMessage',
  components: {
    LayoutBlock,
  },
  props: {
    color: {
      type: String,
      required: false,
      default: '#f7f5f5',
    },
    margin: {
      type: String,
      required: false,
      default: '0px 0px',
    },
    content: {
      type: String,
      required: true,
    },
  },
}
</script>
